(function () {
    'use strict';

    function loadLvMegaMenuImages(menuItem) {
        if (!menuItem) return;

        var placeholders = menuItem.querySelectorAll(
            '.lv-megamenu-banner-placeholder[data-lv-image]'
        );

        placeholders.forEach(function (placeholder) {
            var filename = placeholder.getAttribute('data-lv-image');

            if (!filename || placeholder.getAttribute('data-lv-loaded') === 'true') {
                return;
            }

            var img = document.createElement('img');

            img.src = '/cdn/shop/files/' + encodeURIComponent(filename);
            img.alt = '';
            img.loading = 'eager';
            img.fetchPriority = 'high';
            img.setAttribute('role', 'presentation');

            placeholder.setAttribute('data-lv-loaded', 'true');
            placeholder.replaceWith(img);
        });
    }

    document.addEventListener('mouseover', function (event) {
        var menuItem = event.target.closest('.menu-lv-item.has-megamenu');

        if (!menuItem) return;

        loadLvMegaMenuImages(menuItem);
    });
})();